import { PrinterFetchAPI } from '../api/Printer';
import { MachinesFetchAPI } from '../api/Machines';
import printOrderData from '../components/PaymentPost/PrintOrderData';

// Reimprime la factura (o nota de credito) de una orden YA cobrada, sin comanda - mismo JSON que
// components/Orders/OrderDetails.jsx#printOrder(status = true): solo impresoras de tipo Tickets y
// imprimir_comanda "no". El servicio de impresion trae la orden por Id_Orden_Imprimir
// (GET /print/order/:id), asi que aqui solo se arma el trabajo y se entrega por el canal del POS:
//   - Android: window.AndroidBridge.printOrder (via printOrderData)
//   - Windows / servidor intermedio: PrinterFetchAPI.printOrder / printByServerMiddle (localhost:9090)
// Igual que el resto del POS, en Android tambien se intenta el canal HTTP, pero como el puente ya
// entrego el trabajo, un fallo del HTTP ahi NO se trata como error (en Windows si lo es).
export const reprintPaidOrder = async (order) => {
    const token = localStorage.getItem('x-access-machine-token');
    const machine = JSON.parse(localStorage.getItem('machine'));
    if (!order?._id || !machine?.id) throw new Error('No se puede imprimir esta transaccion');

    const response = await PrinterFetchAPI.getPrinter(token, machine.id);
    const printers = response?.data?.printers || [];
    const ticketPrinters = printers.filter((printer) => printer.printer_type === 'Tickets');
    if (ticketPrinters.length === 0) throw new Error('Esta maquina no tiene impresora de tickets asignada');

    const printerNameByType = (type) => printers.find((printer) => printer.printer_type === type)?.printer_name || '';
    const printerIpByType = (type) => printers.find((printer) => printer.printer_type === type)?.ip || '';

    const JsonImprimir = [{
        type_ticket: order.devolution === true ? 'Nota a credito' : 'factura',
        Printers: ticketPrinters,
        Nombre_maquina_impresora: printerNameByType('Tickets'),
        Nombre_cocina_impresora: printerNameByType('Comanda'),
        Nombre_zebra_impresora: '',
        PRINTER_IP: printerIpByType('Tickets'),
        Id_Orden_Imprimir: order._id,
        token,
        transaction_code: order.code,
        amount_item: (order.groups || []).length,
        imprimir_comanda: 'no',
    }];

    const hasAndroidBridge = typeof window !== 'undefined' && typeof window.AndroidBridge?.printOrder === 'function';
    if (hasAndroidBridge) printOrderData(JsonImprimir);

    const externalIp = localStorage.getItem('ip_printer');
    const ipPrint = externalIp || 'localhost';
    try {
        if (ipPrint === 'localhost') {
            const machineResponse = await MachinesFetchAPI.getmachineByid(machine.id, token);
            await PrinterFetchAPI.printOrder(ipPrint, JsonImprimir, machineResponse?.data?.data?.windows_ip);
        } else {
            await PrinterFetchAPI.printByServerMiddle(ipPrint, JsonImprimir);
        }
    } catch (err) {
        if (!hasAndroidBridge) throw err;
    }

    return { channel: hasAndroidBridge ? 'android' : 'windows' };
};
